import angular from 'angular';
import ForecastOpmCtrl from "./ForecastOpmCtrl";
import ForecastOpmService from "./ForecastOpmService";

export default angular
  .module('forecast-opm', [])
  .config(function routes($stateProvider) {
    $stateProvider
      .state('forecast-opm', {
        url: '/forecast/opm',
        template: require('./opm.html'),
        controller: ForecastOpmCtrl,
        controllerAs: 'ctrl',
      })
  })
  .service('ForecastOpmService', ForecastOpmService)
  .name;



// WEBPACK FOOTER //
// ./src/ForecastOpm/index.js